import { createContext, type ReactNode, useContext, useState } from "react";

type PublicModeContextValue = {
	isPublic: boolean;
	setIsPublic: (value: boolean) => void;
};

const PublicModeContext = createContext<PublicModeContextValue | undefined>(
	undefined,
);

export const PublicModeProvider = ({ children }: { children: ReactNode }) => {
	const [isPublic, setIsPublic] = useState(false);
	return (
		<PublicModeContext.Provider value={{ isPublic, setIsPublic }}>
			{children}
		</PublicModeContext.Provider>
	);
};

export const usePublicMode = () => {
	const ctx = useContext(PublicModeContext);
	if (!ctx)
		throw new Error("usePublicMode must be used inside PublicModeProvider");
	return ctx;
};
